import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IMaterial } from "../../utils/types/models";

export default createEntityReducer<IMaterial>(Endpoint.Materials, Endpoint.MaterialsList);
